import { axiosGetHandler } from '../config';
import axios from '_lib/encrypt/axios';
const BASE_API =
  process.env.NODE_ENV === 'production' && (window.location.origin.includes('xiaoheihe.cn') || window.location.origin.includes('chat.top'))
    ? 'https://chat.xiaoheihe.cn'
    : 'https://chat.debugmode.cn';

function addParams(args) {
  return {
    ...args,
    client_type: 'heybox_chat',
    chat_os_type: 'web',
  };
}

axios.interceptors.request.handlers.unshift({
  fulfilled: (config) => {
    config.url = config.url.replace(/http[s]*:\/\/.*?\//, BASE_API + '/');
    return config;
  },
  rejected: null,
});

// 获取小程序落地页信息
export function getMpShareInfo(args) {
  let url = '/chatroom/v2/minipro/share_page';
  return axiosGetHandler(url, addParams(args));
}

// 数据上报
export function reportExposure() {
  return axiosGetHandler('/chatroom/report/minipro_share', addParams({ _notip: true }));
}
